import type { ISortOrder } from "../unit-catalog.types";

export const reverseOrder = (order: ISortOrder) => {
  const map = { asc: "desc", desc: "asc" };
  return map[order] as ISortOrder;
};
